module.exports = __webpack_public_path__ + "img/dotfiles.29b7757c.webp";